import { Mutations } from '@/store/types';
import Store from '@/store';

export class FairOrderDetailService {
  private static instance = new FairOrderDetailService();

  public static singleton(): FairOrderDetailService {
    return this.instance;
  }

  private constructor() {
  }

  public saveRequestedDeliveryDay(day?: Date) {
    Store.commit(
      {
        type: Mutations.FairOrderDetail.setRequestedDeliveryDay,
        requestedDeliveryDay: day
      }
    );
  }

  public saveRequestedDeliveryDayFreshProducts(day?: Date) {
    Store.commit(
      {
        type: Mutations.FairOrderDetail.setRequestedDeliveryDayFreshProducts,
        requestedDeliveryDayFreshProducts: day
      }
    );
  }

  public resetCheckoutState() {
    Store.commit(Mutations.FairOrderDetail.resetCheckoutState);
  }
}
